export default __webpack_public_path__ + "static/media/ico_status.1df5e282.svg";